import React, { useState } from "react";
import styles from "./components/Css/NonFictional.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Mousewheel } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";
import { useUniqueAudiosByCategory } from "../hooks/useChapters";
import Loading from "../common/HousGlass Loader/Loading";

const FictionalAudioBooks = () => {
  const { audios, isLoading: audiosLoading } = useUniqueAudiosByCategory('Fictional', 'Audio', 'Audio Book', 1, 10);
  const [visibleBooks, setVisibleBooks] = useState(10);
  const navigate = useNavigate();
  
  if (audiosLoading) {
    return <div className={styles.loading}><Loading /></div>;
  }
  
  // Sort and number the audios
  const sortedAndNumberedAudios = [...audios]
    .map((item, index) => ({
      ...item,
      number: index + 1
    }))
    .slice(0, 10); // Keep only the top 10 items
  
  const handleCardClick = (slug) => {
    navigate(`/audio-play/${slug}`);
  };
  
  return (
    <div className={styles.container}>
      <div className={styles.boxedWrapper}>
        <div className={styles.header}>
          <h2>Fictional</h2>
          <button
            onClick={() => navigate("/view-all/Fictional")}
            className={styles.viewAllButton}
          >
            View all &gt;
          </button>
        </div>
        <div className={styles.bookList}>
          <Swiper
            modules={[Navigation, Mousewheel]}
            navigation
            mousewheel={{ forceToAxis: true, invert: false }}
            spaceBetween={20}
            slidesPerView={1}
            breakpoints={{
              320: { slidesPerView: 3, spaceBetween: 10 },
              480: { slidesPerView: 3, spaceBetween: 12 },
              768: { slidesPerView: 4, spaceBetween: 20 },
              1024: { slidesPerView: 6, spaceBetween: 20 },
              1200: { slidesPerView: 7, spaceBetween: 20 },
              1440: { slidesPerView: 7, spaceBetween: 20 },
            }}
            className={styles.swiper}
          >
            {sortedAndNumberedAudios.slice(0, visibleBooks).map((item) => {
              return (
                <SwiperSlide key={item.audio_id}>
                  <div
                    className={styles.bookItem}
                    role="button"
                    tabIndex={0}
                    onClick={() => handleCardClick(item.audio_slug)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        handleCardClick(item.audio_slug);
                      }
                    }}
                  >
                    <div className={styles.imageContainer}>
                      <img
                        src={item.cover_image_url || (window.innerWidth > 768 
                          ? item.computer_image_url 
                          : item.mobile_image_url)}
                        alt={item.audio_title}
                        className={styles.bookImage}
                      />
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
        {visibleBooks < sortedAndNumberedAudios.length && (
          <button
            onClick={() => setVisibleBooks((prev) => prev + 5)}
            className={styles.viewAllButton}
          >
            Show More
          </button>
        )}
      </div>
    </div>
  );
};

export default FictionalAudioBooks;